import ScrollMenu from 'react-horizontal-scrolling-menu';
import {MenuItems, Void} from 'react-horizontal-scrolling-menu/build/types';

class CustomScrollMenu extends ScrollMenu {
  public getCenterOffset = ({
    items,
    menuWidth,
  }: {
    items?: MenuItems;
    menuWidth?: number;
  }): number => {
    const all = this.getMenuItems();

    const menuItems = items ?? all;
    if (menuItems && !menuItems.length) {
      return 0;
    }

    const wrapperWidth = menuWidth ?? this.getWidth({items: all}).menuWidth;

    const singleItemWidth = Math.floor(this.getItemsWidth({items: menuItems}) / menuItems.length);

    const offset = (wrapperWidth - singleItemWidth) / 2;

    return offset;
  };

  public getPagesOffsets = ({
    items,
    allItemsWidth,
    menuWidth,
    offset,
  }: {
    items?: MenuItems;
    allItemsWidth?: number;
    menuWidth?: number;
    offset?: number;
  }): {
    firstPageOffset: number;
    lastPageOffset: number;
  } => ({firstPageOffset: 0, lastPageOffset: 0});

  // eslint-disable-next-line consistent-return
  public handleArrowClick = (left = true): Void => {
    const {alignCenter, rtl} = this.props;
    const allItems = this.getMenuItems();
    const allItemsWidth = this.getItemsWidth({items: allItems});
    const {menuWidth} = this.getWidth({items: allItems});

    if (!alignCenter && !left && allItemsWidth < menuWidth) {
      return false;
    }
    let newTranslate = 0;

    const visibleItems = this.getVisibleItems({});
    const firstItemVisible = visibleItems[0] && visibleItems[0][1].index === 0;
    const lastItemVisible =
      visibleItems.slice(-1)[0] && visibleItems.slice(-1)[0][1].index === allItems.length - 1;

    const transl = this.getOffset(left);

    if (left && (firstItemVisible || this.itBeforeStart(transl))) {
      newTranslate = this.getOffsetAtStart();
    } else if (!left && (lastItemVisible || this.itAfterEnd(transl))) {
      newTranslate = this.getOffsetAtEnd();
    } else {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      const visibleItems = () => this.getVisibleItems({offset: transl});
      const centerOffset = alignCenter ? this.getCenterOffset({items: visibleItems()}) : 0;

      newTranslate =
        transl +
        // eslint-disable-next-line no-nested-ternary
        (rtl ? (left ? centerOffset + menuWidth : -centerOffset - menuWidth) : centerOffset);

      if (newTranslate > -1) newTranslate = -1; // accomodates border width
      if (newTranslate < -(allItemsWidth - 1)) newTranslate = -(allItemsWidth - 1); // accomodates border width
    }

    this.setState({
      startDragTranslate: 0,
      translate: newTranslate,
      xDraggedDistance: 0,
      xPoint: CustomScrollMenu.defaultProps.xPoint,
    });
  };
}

export default CustomScrollMenu;
